const CURRENCIES = [
  "AED - United Arab Emirates Dirham",
  "AFN - Afghan Afghani",
  "ALL - Albanian Lek",
  "AMD - Armenian Dram",
  "ANG - Netherlands Antillean Guilder",
  "AOA - Angolan Kwanza",
  "ARS - Argentine Peso",
  "AUD - Australian Dollar",
  "AWG - Aruban Florin",
  "AZN - Azerbaijani Manat",
  "BAM - Bosnia and Herzegovina Convertible Mark",
  "BBD - Barbados Dollar",
  "BDT - Bangladeshi Taka",
  "BGN - Bulgarian Lev",
  "BHD - Bahraini Dinar",
  "BIF - Burundian Franc",
  "BMD - Bermudian Dollar",
  "BND - Brunei Dollar",
  "BOB - Bolivian Boliviano",
  "BRL - Brazilian Real",
  "BSD - Bahamian Dollar",
  "BTN - Bhutanese Ngultrum",
  "BWP - Botswana Pula",
  "BYN - Belarusian Ruble",
  "BZD - Belize Dollar",
  "CAD - Canadian Dollar",
  "CDF - Congolese Franc",
  "CHF - Swiss Franc",
  "CLP - Chilean Peso",
  "CNY - Chinese Yuan",
  "COP - Colombian Peso",
  "CRC - Costa Rican Colon",
  "CUP - Cuban Peso",
  "CZK - Czech Koruna",
  "DKK - Danish Krone",
  "DOP - Dominican Peso",
  "DZD - Algerian Dinar",
  "EGP - Egyptian Pound",
  "ERN - Eritrean Nakfa",
  "ETB - Ethiopian Birr",
  "EUR - Euro",
  "FJD - Fiji Dollar",
  "GBP - British Pound Sterling",
  "GEL - Georgian Lari",
  "GHS - Ghanaian Cedi",
  "GMD - Gambian Dalasi",
  "GNF - Guinean Franc",
  "GTQ - Guatemalan Quetzal",
  "HKD - Hong Kong Dollar",
  "HNL - Honduran Lempira",
  "HRK - Croatian Kuna",
  "HTG - Haitian Gourde",
  "HUF - Hungarian Forint",
  "IDR - Indonesian Rupiah",
  "ILS - Israeli New Shekel",
  "INR - Indian Rupee",
  "IQD - Iraqi Dinar",
  "IRR - Iranian Rial",
  "ISK - Icelandic Krona",
  "JMD - Jamaican Dollar",
  "JOD - Jordanian Dinar",
  "JPY - Japanese Yen",
  "KES - Kenyan Shilling",
  "KRW - South Korean Won",
  "KWD - Kuwaiti Dinar",
  "KZT - Kazakhstani Tenge",
  "LBP - Lebanese Pound",
  "LKR - Sri Lankan Rupee",
  "LRD - Liberian Dollar",
  "LSL - Lesotho Loti",
  "LYD - Libyan Dinar",
  "MAD - Moroccan Dirham",
  "MDL - Moldovan Leu",
  "MGA - Malagasy Ariary",
  "MXN - Mexican Peso",
  "MYR - Malaysian Ringgit",
  "NGN - Nigerian Naira",
  "NOK - Norwegian Krone",
  "NPR - Nepalese Rupee",
  "NZD - New Zealand Dollar",
  "OMR - Omani Rial",
  "PAB - Panamanian Balboa",
  "PEN - Peruvian Sol",
  "PHP - Philippine Peso",
  "PKR - Pakistani Rupee",
  "PLN - Polish Zloty",
  "PYG - Paraguayan Guarani",
  "QAR - Qatari Riyal",
  "RON - Romanian Leu",
  "RSD - Serbian Dinar",
  "RUB - Russian Ruble",
  "SAR - Saudi Riyal",
  "SEK - Swedish Krona",
  "SGD - Singapore Dollar",
  "THB - Thai Baht",
  "TND - Tunisian Dinar",
  "TRY - Turkish Lira",
  "TTD - Trinidad and Tobago Dollar",
  "UAH - Ukrainian Hryvnia",
  "UGX - Ugandan Shilling",
  "USD - US Dollar",
  "UYU - Uruguayan Peso",
  "VND - Vietnamese Dong",
  "ZAR - South African Rand",
  "ZMW - Zambian Kwacha",
];

export default CURRENCIES;